<template>
	<div>
		<form v-on:submit.prevent="saveVehicle">
			<div>
				<label for="description">Make</label>
				<input
					name="description"
					v-model="editingVehicle.make"
					type="text"
					placeholder="make"
				/>
			</div>
			<div>
				<label for="model">Model</label>
				<input
					name="model"
					v-model="editingVehicle.model"
					type="text"
					placeholder="model"
				/>
			</div>
			<div>
				<label for="year">Year</label>
				<input
					name="year"
					v-model="editingVehicle.year"
					type="text"
					placeholder="year"
				/>
			</div>
			<div>
				<label for="mileage">Mileage</label>
				<input
					name="mileage"
					v-model="editingVehicle.mileage"
					type="text"
					placeholder="mileage"
				/>
			</div>
			<div>
				<label for="description">Description</label>
				<textarea
					name="description"
					v-model="editingVehicle.description"
					placeholder="Description"
				></textarea>
			</div>
			<input type="submit" />
		</form>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import router from '@/router/index.js';

export default {
	name: 'VehicleDetail',
	created() {},
	props: {
		id: {
			type: Number,
			default: 0
		},
		vehicle: {}
	},
	data() {
		return {
			editingVehicle: { ...this.vehicle }
		};
	},
	watch: {
		vehicle() {
			this.editingVehicle = { ...this.vehicle };
		}
	},
	methods: {
		...mapActions('vehicle', [
			'createVehicleAction',
			'updateVehicleAction'
		]),
		saveVehicle() {
			if (this.id == 0) {
				this.createVehicleAction(this.editingVehicle).then(v => {
					router.push({
						name: 'vehicle-detail',
						params: { id: v.id }
					});
					//console.log(this.id);
				});
			} else {
				this.updateVehicleAction(this.editingVehicle);
			}
		}
	}
};
</script>

<style lang="scss" scoped></style>
